module.exports = function() {
  return new Worker(__webpack_public_path__ + "45eff16fbf8637a2.worker.js");
};